import DataGrid, { Column } from 'devextreme-react/data-grid';
import { bllSharedCellStyling } from '../../common/constants/tables/cells/styles/bllSharedCellStyling';
import { BorrowerLendingLimitTableType } from '../../common/constants/tables/BorrowerLendingLimitTableType';
import { currencyCellItemRender } from '../../common/constants/tables/cells/renders/currencyCellItemRender';
import { countCellRender } from '../../common/constants/tables/cells/renders/countCellRender';
import { summaryItemTypeCellRender } from '../../common/constants/tables/cells/renders/summaryItemCellRender';
import { BridgeRows } from '../../common/constants/tables/rows/BridgeRows';
import { BridgeColumns } from '../../common/constants/tables/columns/BridgeColumns';
import { ILoanHistorySummaryTableRow } from '../../common/constants/tables/interfaces/ILoanHistorySummaryTableRow';
import { IBridgeTableRow } from '../../common/constants/tables/interfaces/IBridgeTableRow';

interface BridgeTableProps {
    bridgeData?: IBridgeTableRow[] | undefined;
    onLoanSummaryClick: (loans: ILoanHistorySummaryTableRow[] | undefined) => void;
}
export const BridgeTable: React.FC<BridgeTableProps> = ({ onLoanSummaryClick, bridgeData }) => {
    const rowSpecificCellStyling = (e) => {
        switch (e.row?.data?.summaryItemType) {
            case BridgeRows.BridgeSummary:
                e.cellElement.style.borderTop = '2px solid gray';
                break;
            default:
                break;
        }
    };

    const prepareCells = (e) => {
        //Run shared styling
        bllSharedCellStyling(e);

        //Run row specific styling
        rowSpecificCellStyling(e);
    };

    const showEyeForBridge = (e) => {
        return e.data.summaryItemType === BridgeRows.BridgeSummary;
    };

    return (
        <>
            <DataGrid
                dataSource={bridgeData}
                keyExpr='summaryItemType'
                showBorders={false}
                showRowLines={false}
                rowAlternationEnabled={true}
                remoteOperations={false}
                allowColumnReordering={true}
                allowColumnResizing={true}
                noDataText='No Bridge Information Available'
                onCellPrepared={(e) => {
                    prepareCells(e);
                }}
                style={{ padding: '10px' }}
            >
                <Column
                    dataField={BridgeColumns.SummaryItemType}
                    caption=''
                    alignment={'left'}
                    width={160}
                    cellRender={(e) =>
                        summaryItemTypeCellRender(e, BorrowerLendingLimitTableType.Bridge, BridgeColumns.SummaryItemType)
                    }
                />
                <Column
                    dataField={BridgeColumns.OutstandingAmount}
                    caption='Outstanding'
                    width={140}
                    alignment={'right'}
                    cellRender={(e) => currencyCellItemRender(e, BorrowerLendingLimitTableType.Bridge)}
                />
                <Column
                    dataField={BridgeColumns.OutstandingNumber}
                    caption=''
                    width={70}
                    alignment={'left'}
                    cellRender={(e) =>
                        countCellRender(
                            e, // only the row data, no circular refs
                            () => onLoanSummaryClick(e.data.outstandingLoans),
                            showEyeForBridge
                        )
                    }
                />
                <Column
                    dataField={BridgeColumns.BfiRepaysAmount}
                    caption='BFI Repays'
                    width={120}
                    alignment={'right'}
                    cellRender={(e) => currencyCellItemRender(e, BorrowerLendingLimitTableType.Bridge)}
                />
                <Column
                    dataField={BridgeColumns.BfiRepaysNumber}
                    caption=''
                    alignment={'left'}
                    cellRender={(e) =>
                        countCellRender(
                            e, // only the row data, no circular refs
                            () => onLoanSummaryClick(e.data.bfiRepaysLoans),
                            showEyeForBridge
                        )
                    }
                />
            </DataGrid>
        </>
    );
};
